import { useState } from "react"; // これを追加！
import { Title, Content } from "./index";
// import Title from "./Title"; // { } なしで直接呼ぶ
// import Content from "./Content"; // { } なしで直接呼ぶ
const Article = (props) => {
  //1. useStateによるstateの宣言
  // const [現在の状態, 更新関数] = useState(初期値);
  const [isPublished, setIsPublished] = useState(false);
  //後に実行するので変数publishArticleに更新関数を格納
  const publishArticle = () => {
    //2.stateの更新
    //更新関数(新しい値);
    setIsPublished(true);
  };

  return (
    <div style={{ marginBottom: "20px", borderBottom: "1px solid #ccc", paddingBottom: "10px" }}>
      <Title title={props.title} />
      <Content content={props.content} />
      {/* 状態によって表示を変える（三項演算子） */}
      <p>状態：{isPublished ? "✅ 公開中" : "☁️ 未公開"}</p>

      {/* すでに公開済みの場合はボタンを出さない、という工夫もできます */}
      {!isPublished && <button onClick={publishArticle}>公開する</button>}
    </div>
  );
};
export default Article;
// && は「偽（falsy）」を探す旅に出る、とイメージしましょう。
//&& の旅: 全てが true なら最後の値を、途中で false に出会ったらその false を返します。
